"use client";
import { FC, ReactElement, createContext, useContext } from "react";

type PageNameProviderProps = {
  pageName: string;
  children: ReactElement;
};

const PageNameContext = createContext<string>("");

export const usePageNameContext = () => useContext(PageNameContext);

const PageNameProvider: FC<PageNameProviderProps> = ({ pageName, children }) => (
  <PageNameContext.Provider value={pageName}>{children}</PageNameContext.Provider>
);

export default PageNameProvider;
